import * as z from 'zod';
import { shapeSchema } from '@ais-ui/utils';
import { AreaDetectorFormValues } from '../Area/areaForm';
import { GroundingDetectorFormValues } from '../Grounding/groundingForm';
import { CableDetectorFormValues } from '../Cable/cableForm';
import { LineDetectorFormValues } from '../Line/lineForm';

export type DetectorType = 'area' | 'fishing' | 'cable' | 'line' | 'grounding';

export type DetectorFormTypes =
  | AreaDetectorFormValues
  | GroundingDetectorFormValues
  | CableDetectorFormValues
  | LineDetectorFormValues;

export const mutualDetectorFormSchema = z.object({
  name: z.string(),
  enabled: z.boolean(),
  shapeId: z.string().optional(),
  shape: shapeSchema.optional(),
  selectedGroups: z.array(
    z.object({
      value: z.string(),
      label: z.string(),
    })
  ),
  filterId: z.string().nullable(),
  severity: z.string(),
  maintainShiplist: z.boolean(),
  acknowledgeRequired: z.boolean(),
  emails: z.array(z.string().email()),
  phones: z.array(z.string()),
});

export const mutualDetectorDefaultValues = {
  enabled: true,
  selectedGroups: [],
  filterId: 'no-filter',
  severity: 'note',
  maintainShiplist: false,
  acknowledgeRequired: false,
  emails: [],
  phones: [],
};
